import React from 'react';

type Tone = 'info' | 'warn' | 'ok';

export type CalloutProps = React.HTMLAttributes<HTMLDivElement> & {
  tone?: Tone;
};

const toneClass: Record<Tone, string> = {
  info: 'callout-info',
  warn: 'callout-warn',
  ok: 'callout-ok',
};

export const Callout: React.FC<CalloutProps> = ({ tone = 'info', className = '', ...rest }) => (
  <div className={`callout ${toneClass[tone]} ${className}`} {...rest} />
);
